/* global ENABLE_ROUTE_DEBUGGING, IS_DEBUG */
import moment from 'moment'

import packageJSON from '../package.json'

// configure moment globally
moment.locale('de')

export const otherwiseConfigBlock = (
  $urlRouterProvider,
  $locationProvider,
  $localStorageProvider,
  $sessionStorageProvider,
  $compileProvider,
) => {
  'ngInject'
  $urlRouterProvider.otherwise(($injector, $location) => {
    const state = $injector.get('$state')
    const url = $location.path()
    const validCustomer = /\/customers\/(\d+)\/.*$/
    const validCustomerAndTasksite = /\/customers\/(\d+)\/tasksites\/(\w+)\/.*/

    let isValidCustomerAndTasksite = validCustomerAndTasksite.exec(url)
    let isValidCustomer = validCustomer.exec(url)

    if (isValidCustomerAndTasksite) {
      state.go('customers.customer.tasksites.orders', {
        customerId: isValidCustomerAndTasksite[1],
        tasksiteId: isValidCustomerAndTasksite[2],
      })
    } else if (isValidCustomer) {
      state.go('customers.customer.tasksites', { customerId: isValidCustomer[1] })
    } else state.go('login')

    $compileProvider.debugInfoEnabled(IS_DEBUG)
  })
  $locationProvider.html5Mode(true)
  $localStorageProvider.setKeyPrefix('umsweb.')
  $sessionStorageProvider.setKeyPrefix('umsweb.')
}

// Enable tracing of each TRANSITION... (check the javascript console)
// This syntax '$trace.enable(1)' is an alternative to '$trace.enable('TRANSITION')'.
// Besides "TRANSITION", you can also enable tracing for : "RESOLVE", "HOOK", "INVOKE", "UIVIEW", "VIEWCONFIG"
export const traceRunBlock = ($trace) => {
  'ngInject'
  if (ENABLE_ROUTE_DEBUGGING) $trace.enable(1)
}

export class ApiFactory {
  constructor($q, $injector) {
    'ngInject'
    Object.assign(this, { $q, $injector })
  }

  /**
   * add app headers to requests
   * @param config
   * @returns {*}
   */
  request(config) {
    const locale = navigator.language || 'de-DE'
    config.headers['x-app-version'] = packageJSON.version
    config.headers['x-app-type'] = 'PORTAL'
    config.headers['x-app-language'] = 'de'
    config.headers['x-device-platform'] = 'WEB'
    config.headers['x-device-language'] = locale.split('-')[0]
    config.headers['x-device-country'] = locale.split('-')[1]
    return config
  }

  static factory($q, $injector) {
    'ngInject'
    return new ApiFactory($q, $injector)
  }
}

export const apiConfigBlock = ($httpProvider) => {
  'ngInject'
  $httpProvider.interceptors.push('ApiFactory')
}



// WEBPACK FOOTER //
// ./app/app.config.js